import { IUploadAvatarRequest } from "@api/models/request/IUploadAvatarRequest";
import { uploadAvatar } from "api/services/user-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useUploadAvatar = () => {
    const { callAPI, loading } = useWorkspaceApiCall<IUploadAvatarRequest, any>(uploadAvatar, 'profile.uploadAvatar.success', 'profile.uploadAvatar.error');

    return { uploadAvatar: callAPI, uploadAvatarPending: loading }
}